/*A collection of user objects*/
import TeamMember from "@/types/Team/TeamMember";
class TeamMemberList {
    teamMembers = []; // the collection of teams.
    constructor(jsonData) {
        if (jsonData !== null) {
            try {
                jsonData.forEach((team) => {
                    this.teamMembers.push(new TeamMember(team)); //adds a new team to the array
                });
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/TeamMemberList.ts -> constructur');
            }
        }
    }
}
export default TeamMemberList;
